import { lazy, useCallback, useEffect } from 'react';

import { useOpenAuthWizard } from '../features/auth/useOpenAuthWizard';
import { componentsRegistry } from '../services/componentsRegistry';
import type { PortalOptions } from '../stores/portal/PortalStore';

const phoneVerificationWizard = lazy(() =>
  import('../features/auth/wizards/PhoneVerificationWizardV2').then((m) => ({ default: m.PhoneVerificationWizardV2 })),
);

export function usePhoneVerifyDialog() {
  const { openAuthWizard } = useOpenAuthWizard();

  useEffect(() => {
    componentsRegistry.registerComponent('phoneVerificationWizard', phoneVerificationWizard);
  }, []);

  const openVerifyPhoneDialog = useCallback(
    (onSuccess?: VoidFunction, portalOptions: PortalOptions = {}) => {
      openAuthWizard('phoneVerificationWizard', {
        ...portalOptions,
        force: true,
        onSuccess,
      });
    },
    [openAuthWizard],
  );

  return {
    openVerifyPhoneDialog,
  };
}
